import {Fee, Order} from "../dtos/orderResponse"

export const getRetailDeliveryFees = (order: Order) => {
	return getAdditionalFees(order, "RetailDeliveryFee")
}
export const getBulkyChargeFees = (order: Order) => {
	return getAdditionalFees(order, "BulkyItemCharge")
}
const getAdditionalFees = (order: Order, feeType: string) => {
	let retailDeliveryFees: Fee[] = []
	order.orderData.lineItems.forEach((item) => {
		if (
			item.corePricing &&
			item.corePricing.additionalFees &&
			item.corePricing.additionalFees.feesV2
		) {
			const itemRetailDeliveryFees = item.corePricing.additionalFees.feesV2.filter(
				(fee) => fee.feeType === feeType
			)
			if (itemRetailDeliveryFees.length > 0) {
				retailDeliveryFees.push(...itemRetailDeliveryFees)
			}
		}
	})
	const sum = retailDeliveryFees
		.map((fee) => {
			if (fee.discountedPriceCents && fee.discountedPriceCents.taxed) {
				return fee.discountedPriceCents.taxed
			}
			return 0
		})
		.reduce((accumulator, currentValue) => {
			if (typeof currentValue === "number") {
				return accumulator + currentValue
			}
			return accumulator
		}, 0)
	return sum
}
export const getFeeName = (fee: Fee): string => {
	if (fee.feeName && fee.feeName !== "") {
		return fee.feeName
	} else {
		switch (fee.feeType) {
			case "SetupFee":
				return "Setup"
			case "PostageFee":
				return "Postage"
			case "MailingServiceFee":
				return "Mailing service"
			case "RushProcessingFee":
				return "Rush processing"
			case "RetailDeliveryFee":
				return "Retail delivery"
			case "BulkyItemCharge":
				return "Bulky item charge"
			case "ImportSurcharge":
				return "Surcharge"
			default:
				return camelCaseToWords(fee.feeType)
		}
	}
}
export const getSurchargeTooltipMessage = (): string => {
	return "Due to recent changes to import regulations, some of our products are now subject to higher costs when shipping to the United States."
}

function camelCaseToWords(s: string) {
	const result = s.replace(/([A-Z])/g, " $1")
	return result.charAt(0).toUpperCase() + result.slice(1)
}
